import { IDatabaseItem } from "../interfaces";

export const DUPLO_ITEMS: Array<IDatabaseItem> = [
	{
		title: "Duplo - 10872 most",
		images: [{
			src: "01.webp",
			large: "01-large.webp",
		}, {
			src: "02.webp",
			large: "02-large.webp",
		}],
	},
	{
		title: "Duplo - 10874 vláček a koleje",
		images: [{
			src: "03.webp",
			large: "03-large.webp",
		}, {
			src: "04.webp",
			large: "04-large.webp",
		}],
	},
	{
		title: "Duplo - 10882 náhradní koleje",
		images: [{
			src: "05.webp",
			large: "05-large.webp",
		}, {
			src: "06.webp",
			large: "06-large.webp",
		}],
	},
	{
		title: "Duplo - 10909 srdíčkový box",
		images: [{
			src: "07.webp",
			large: "07-large.webp",
		}, {
			src: "08.webp",
			large: "08-large.webp",
		}],
	},
	{
		title: "Duplo - 10931 bagr",
		images: [{
			src: "09.webp",
			large: "09-large.webp",
		}, {
			src: "10.webp",
			large: "10-large.webp",
		}],
	},
	{
		title: "Duplo - 10949 zvířátka",
		images: [{
			src: "11.webp",
			large: "11-large.webp",
		}, {
			src: "12.webp",
			large: "12-large.webp",
		}],
	},
	{
		title: "Duplo - 10954 vláček",
		images: [{
			src: "13.webp",
			large: "13-large.webp",
		}, {
			src: "14.webp",
			large: "14-large.webp",
		}],
	},
];
